var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":"Data Pengguna"},scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [_c('v-btn',{attrs:{"small":""},on:{"click":function($event){_vm.showRolesPage = true}}},[_vm._v("+ Role")])]},proxy:true}])},[_c('Grid',{staticClass:"dense",staticStyle:{"height":"calc(100vh - 120px)"},attrs:{"datagrid":_vm.users,"dbref":"Arch.User","doRebind":_vm.gridRebind,"columns":[
      {
        name: 'Username',
        value: 'Username',
        width: '150px',
        editable: {
          com: 'Input',
        },
      },
      {
        name: 'Password',
        value: 'Password',
        width: '120px',
        editable: {
          com: 'Input',
          type: 'password',
        },
      },
      {
        name: 'Nama Lengkap',
        value: 'FullName',
        width: '180px',
        editable: {
          com: 'Input',
        },
      },
      {
        name: 'Aktif ?',
        value: 'IsActive',
        width: '70px',
        editable: {
          com: 'Checkbox',
        },
      },
      {
        name: 'Role',
        class: 'plain',
        value: 'RolePositionName',
        editable: {
          com: 'Select',
          value: 'RolePositionID',
          text: 'RolePositionName',
          dbref: 'Arch.SelRolePosition',
        },
      },
      {
        name: 'Balai',
        class: 'plain',
        value: 'NamaBalai',
        editable: {
          com: 'Select',
          value: 'CityID',
          text: 'NamaBalai',
          dbref: 'MST.SelBalai',
        },
      } ]},on:{"update:datagrid":function($event){_vm.users=$event}},scopedSlots:_vm._u([{key:"row-IsActive",fn:function(ref){
    var row = ref.row;
return [_c('div',{attrs:{"center":""}},[_c('v-icon',{attrs:{"color":row.IsActive ? 'primary' : ''}},[_vm._v(" "+_vm._s(row.IsActive ? 'mdi-checkbox-marked' : 'mdi-crop-square')+" ")])],1)]}},{key:"row-RolePositionName",fn:function(ref){
    var row = ref.row;
return [_c('v-btn',{attrs:{"text":"","small":"","color":"primary"},on:{"click":function($event){return _vm.ShowRoleAccess(row.RolePositionID)}}},[_vm._v(" "+_vm._s(row.RolePositionName)+" ")])]}}])}),_c('Modal',{attrs:{"id":"modal-role-access","show":_vm.roleAccess,"title":"ROLE ACCESS","width":"350px"},on:{"update:show":function($event){_vm.roleAccess=$event},"submit":_vm.SubmitRoleAccess}},[_c('RoleAccessPage',{attrs:{"roleId":_vm.roleId,"page-data":_vm.roleAccessData},on:{"update:pageData":function($event){_vm.roleAccessData=$event},"update:page-data":function($event){_vm.roleAccessData=$event}}})],1),_c('Modal',{attrs:{"id":"modal-roles","show":_vm.showRolesPage,"title":"ROLES","cancelText":"TUTUP","submitText":''},on:{"update:show":function($event){_vm.showRolesPage=$event}}},[_c('RolesPage',{attrs:{"page-data":_vm.rolesData},on:{"update:pageData":function($event){_vm.rolesData=$event},"update:page-data":function($event){_vm.rolesData=$event}}})],1),_c('Modal',{attrs:{"id":"modal-roles","show":_vm.showAreaAccess,"title":"AREA AKSES"},on:{"update:show":function($event){_vm.showAreaAccess=$event},"submit":_vm.SubmitAreaAccess}},[_c('AreaAccessPage',{attrs:{"userId":_vm.userId,"page-data":_vm.areaAccessData},on:{"update:pageData":function($event){_vm.areaAccessData=$event},"update:page-data":function($event){_vm.areaAccessData=$event}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }